export default __webpack_public_path__ + "static/cli_unimarc-e5eadf3b165905361a0c605ff76f35f3.png";